import { useNavigate } from "react-router-dom";
import SuccessIcon from "../../../assets/icons/success.svg?react";
import { Button } from "../../../components/Button";
import { USER_TYPES } from "../../../constant";
import { clearCookies } from "../../../services/utils";

export function ResetPasswordSuccess({ userType }: { userType: string }) {
  const navigate = useNavigate();
  const handleLoginClick = () => {
    clearCookies();
    navigate(userType === USER_TYPES.PROVIDER ? "/provider/login" : "/login");
  };
  return (
    <div className="rounded-lg w-[438px] p-8 bg-white flex flex-col items-center mx-3">
      <SuccessIcon />
      <div className="text-black text-[28px] font-semibold text-center mt-1 mb-4">
        Your password has been changed successfully!
      </div>
      <Button
        className="!rounded-full w-full mt-8"
        variant="primary"
        onClick={handleLoginClick}
      >
        Go to login
      </Button>
    </div>
  );
}
